import { productGroupLevel } from '../constant';

export default class ClientLogger {
  constructor(instrumentation) {
    this.scenario = instrumentation.productGroupGrid.create();
    this.applyFilterActivity = this.scenario.applyFilter.create();
    this.toggleGridActivity = this.scenario.toggleGrid.create();
    this.changeSelectedColumnActivity = this.scenario.changeSelectedColumns.create();
    this.recordBidChangeActivity = this.scenario.recordBidChange.create();
  }

  logApplyFilter({
    filter,
    level,
    isTreeView,
  }) {
    const message = this.getMessage({ filterQuery: filter.query }, level, isTreeView);
    this.applyFilterActivity.trace(message);
  }

  logToggleGrid({
    isTreeView,
  }) {
    const sourceGrid = isTreeView ? 'TreeGrid' : 'FlattenGrid';
    const aimGrid = isTreeView ? 'FlattenGrid' : 'TreeGrid';
    const action = `Toggle from ${sourceGrid} to ${aimGrid}`;
    const message = this.getMessage(action, productGroupLevel.AdGroup, isTreeView);
    this.toggleGridActivity.trace(message);
  }

  logChangeSelectedColumn({
    columns,
    level,
    isTreeView,
  }) {
    const message = this.getMessage({
      description: 'selected columns changed',
      selectedColumns: columns,
    }, level, isTreeView);
    this.changeSelectedColumnActivity.trace(message);
  }

  logChangeBidOrBidBoost({
    itemId,
    updated,
    level,
    isTreeView,
  }) {
    const message = this.getMessage({
      itemId,
      updated,
    }, level, isTreeView);
    this.recordBidChangeActivity.trace(message);
  }

  getMessage(message, level, isTreeView) {
    return JSON.stringify({
      level,
      isTreeView: level !== productGroupLevel.AdGroup ? false : isTreeView,
      version: 'V2',
      message,
    });
  }
}
